/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssetDetails } from './assetDetails';


export interface SharingCollection { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    expiryDate: string;
    userEmails: Array<string>;
    publicLink?: boolean;
    description?: string;
    noDownload?: boolean;
    sharedBy?: string;
    branding?: string;
    linkOpenedByUsers?: Array<string>;
    downloadedByUsers?: Array<string>;
    assetDetails: Array<AssetDetails>;
    coverAssetID?: string;
    collectionID?: string;
    ownerID?: string;
}

